'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Popover = require('components/Popover/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./StatisticsRecipientInfoTooltip.scss');

var StatisticsRecipientInfoTooltip = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsRecipientInfoTooltip, _PureComponent);

  function StatisticsRecipientInfoTooltip() {
    (0, _classCallCheck3.default)(this, StatisticsRecipientInfoTooltip);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientInfoTooltip.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientInfoTooltip)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsRecipientInfoTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipient = _props.recipient;
      var t = this.context.t;


      var overlay = _react2.default.createElement(
        'div',
        { className: 'padding-5' },
        _react2.default.createElement(
          'div',
          null,
          t('ID'),
          ': ',
          recipient.recipientId
        ),
        _react2.default.createElement(
          'div',
          null,
          'IP: ',
          recipient.ip
        )
      );

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Popover2.default,
          { overlay: overlay },
          _react2.default.createElement('i', { className: (0, _bind2.default)(styles.icon, className) })
        )
      );
    }
  }]);
  return StatisticsRecipientInfoTooltip;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  recipient: _propTypes2.default.object
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  recipient: {}
}, _temp);
exports.default = StatisticsRecipientInfoTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsRecipientInfoTooltip/StatisticsRecipientInfoTooltip.js
// module id = 2126
// module chunks = 1